import React from 'react';
import PropTypes from 'prop-types';

import './ProductAnswersList.scss';

import ProductAnswerCard from './ProductAnswerCard';
import { answerPropTypes } from './propTypes';

const ProductAnswerList = ({
	answers, pageNumber, questionPos, fromSearch = false
}) => (
	<div className="ProductAnswersList">
		<div className="ProductAnswersList_container">
			{answers.map((answer) => (
				<div className="ProductAnswersList__content" key={answer.id}>
					<ProductAnswerCard
						answer={answer}
						pageNumber={pageNumber}
						questionPos={questionPos}
						fromSearch={fromSearch}
					/>
				</div>
			))}
			<div className="ProductAnswersList__vote">
				<span className="lpIcon-favoriteselected ProductAnswersList__voteIcon" />
				Vote for the best answer above!
			</div>
		</div>
	</div>
);

ProductAnswerList.propTypes = {
	answers: PropTypes.oneOfType([ PropTypes.shape({}), PropTypes.arrayOf(answerPropTypes) ]),
	pageNumber: PropTypes.number,
	questionPos: PropTypes.number,
	fromSearch: PropTypes.bool
};

export default ProductAnswerList;
